import { Link } from 'gatsby';
import * as React from 'react';

export default function LinkResolver(children, props) {
  const { story, target } = props;
  let { href } = props;

  if (story && story.full_slug) {
    href = story.full_slug;
  }

  if (!href) {
    return children;
  }

  const Tag = target === '_blank' ? 'a' : Link;
  let _href = `/${href}`;
  if (href[0] === '/' || href.includes('http') || href.includes(':')) {
    _href = href;
  }

  return (
    <Tag
      href={_href}
      to={_href}
      target={target}
    >
      {children}
    </Tag>
  );
}
